import React from 'react';
import './CarGrid.css';

// Importing necessary components and utilities
import { PageTitle, Car, PagesNo, CarsSearch, ShowcaseHeader } from '../../../components';
import { useCarFilter, useFilterLoading } from '../../../utils';
import { cars } from '../../../constants';



const CarGrid = () => {  

  // Fetch filtered and paginated car data using the custom hook `useCarFilter`
  const {
    searchKeyword,      // Current search keyword
    matchingCars,       // List of cars matching the search and filters
    sortOption,         // Current sorting option
    currentPage,        // Current page number
    displayedCars,      // Cars to display on the current page
    handleFormSubmit,   // Function to handle search form submission
    handleSort,         // Function to handle sorting changes
    totalPages,         // Total number of pages
    handlePageChange,   // Function to handle page change in pagination
  } = useCarFilter();

  // Use the custom hook `useFilterLoading` to determine if filtering is in progress
  const isFiltering = useFilterLoading(matchingCars, searchKeyword);
 
  return (   
    <> 

      {/* Page title */}
      <PageTitle title={'Car Grid'} page={'Car Grid'} />

      {/* Cars search component */}
      <CarsSearch onFormSubmit={handleFormSubmit} />
  
      {/* Cars section */}
      <section className='cars'>

        {/* Check if there are matching cars */}
        {isFiltering ? null : matchingCars.length === 0 ? (
          // Render "No car found" message if no matching cars
          <div className='no-car-found'>No car found.</div>
        ) : (
          <>

            {/* Car header component */}
            <ShowcaseHeader
              showing={displayedCars.length}  // Number of cars currently displayed
              total={cars.length}             // Total number of cars available
              sortOption={sortOption}         // Current sorting option
              handleSort={handleSort}         // Function to handle sorting changes
              isCar={true}                    // Indicates this is a car showcase
            />

            {/* Car container with grid layout */}
            <div className='car-container grid'>
              {/* Render each car component */}
              {displayedCars.map((car) => {
                return(  
                  <Car key={car.id} car={car} /> // Render a Car component for each car
                )
              })
              }
            </div>

            {/* pagination component */}
            <PagesNo currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
            
          </>
          )}
      </section>
    </>
  )
}

export default CarGrid;